import {
    RECEIVE_HEADING_DETAILS,
    REQUEST_HEADING_DETAILS,
    SET_HEADING_DETAILS_ERROR
    } from '../constants/ActionTypes';

const initialState = {
    isFetching: false,
    isLoadingError: false,
};

export default function headingDetails(state = initialState, action) {
    switch (action.type) {
        case SET_HEADING_DETAILS_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoadingError: true
            };
        case REQUEST_HEADING_DETAILS:
            return {
                ...state,
                isFetching: true,
                isLoadingError: false
            };
        case RECEIVE_HEADING_DETAILS:
            return {
                ...state,
                isFetching: false,
                detailsData: {
                    ...action.data
                }
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/headingDetails.js